import React from "react";
import {
  Box,
  Typography,
  NewGrade as Grade,
  NewGradeValueOptions,
} from "@bca/ui-library";
import KeyDecisionInfoContainer from "./KeyDecisionInfoContainer";
import getBatteryGradeLetter from "../utils/getBatteryGradeLetter";

const BatteryReport: React.FunctionComponent<{
  condition: number;
  onOpenReport: () => void;
  viewport?: string;
}> = ({ condition, onOpenReport, viewport }) => {
  return (
    <KeyDecisionInfoContainer
      onClick={onOpenReport}
      viewport={viewport}
      anchorLink={null}
    >
      {viewport !== "mobile" ? (
        <>
          <Box
            display="flex"
            alignItems="baseline"
            justifyContent="space-between"
            width="100%"
            aria-label="Desktop battery report"
          >
            <Typography
              variant="body-small"
              fontWeight="medium"
              m={0}
              color="footer-blue"
            >
              Battery
            </Typography>
          </Box>
          <Grade
            value={getBatteryGradeLetter(condition) as NewGradeValueOptions}
          />
        </>
      ) : (
        <Box
          display="flex"
          alignItems="baseline"
          justifyContent="space-between"
          width="100%"
          aria-label="Mobile battery report"
        >
          <Box width="100%" display="flex" alignItems="center">
            <Grade
              value={getBatteryGradeLetter(condition) as NewGradeValueOptions}
            />
            <Typography variant="body-small" m={0} ml={2} fontWeight="medium">
              Battery
            </Typography>
          </Box>
        </Box>
      )}
    </KeyDecisionInfoContainer>
  );
};

export default BatteryReport;
